export default "/images/vendor/react-images-upload/UploadIcon.svg?469126df4127e870c21611e576b85d00";